import { render, staticRenderFns } from "./MarkupsView.vue?vue&type=template&id=c30d25b2"
import script from "./MarkupsView.vue?vue&type=script&lang=js"
export * from "./MarkupsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports